import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Box, IconButton, Stack } from "@mui/material";
import { genProductPriceLabel } from "mt-shared/genProductPriceLabel";
import { Dispatch, SetStateAction } from "react";
import { PriceDetails, ProductPrice } from "..";

type GuestPickerProps = {
  prices: ProductPrice[];
  details: PriceDetails[];
  setDetails: Dispatch<SetStateAction<PriceDetails[]>>;
  bookingSize: number;
  maxBookingSize: number;
};
export default function GuestPicker({
  prices,
  details,
  setDetails,
  bookingSize,
  maxBookingSize,
}: GuestPickerProps) {
  const canAddMoreGuests = bookingSize < maxBookingSize;

  return (
    <Stack spacing={2}>
      {prices.map((price) => {
        const detail = details.find((detail) => detail.price.id === price.id);
        return (
          <Stack
            key={price.id}
            direction="row"
            spacing={2}
            alignItems={"center"}
          >
            <Box sx={{ mb: "10px", width: "70%" }}>
              <span style={{ fontWeight: "bold" }}>
                {Intl.NumberFormat("ja-JP", {
                  style: "currency",
                  currency: price.currency,
                }).format(price.amount)}
              </span>
              <br />
              <span>{genProductPriceLabel(price, { variant: "long" })}</span>
              <br />
              <span style={{ fontSize: "10px" }}>
                {price.translation?.description}
              </span>
            </Box>
            <Box style={{ width: "20%" }}>
              <Stack
                direction="row"
                alignItems={"center"}
                justifyContent={"space-between"}
                spacing={2}
              >
                <IconButton
                  disabled={detail?.quantity === price.minimum}
                  onClick={() => {
                    setDetails(
                      details.map((detail) =>
                        detail.price.id === price.id &&
                        detail.quantity > price.minimum
                          ? { ...detail, quantity: detail.quantity - 1 }
                          : detail,
                      ),
                    );
                  }}
                >
                  <RemoveCircleIcon />
                </IconButton>
                <span style={{ fontSize: "20px" }}>{detail?.quantity}</span>
                <IconButton
                  disabled={!canAddMoreGuests}
                  onClick={() =>
                    setDetails(
                      details.map((detail) =>
                        detail.price.id === price.id && canAddMoreGuests
                          ? { ...detail, quantity: detail.quantity + 1 }
                          : detail,
                      ),
                    )
                  }
                >
                  <AddCircleIcon />
                </IconButton>
              </Stack>
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
}
